import { Navigate } from "react-router";
import { useEvents } from "@/api/hooks";
import { useAuth } from "@/providers/auth-provider";
import { Skeleton } from "@/components/ui/skeleton";

function findClosestEvent(events: { id: string; start_date: string }[]) {
  const now = Date.now();
  return events.reduce((best, ev) => {
    const diff = Math.abs(new Date(ev.start_date).getTime() - now);
    const bestDiff = Math.abs(new Date(best.start_date).getTime() - now);
    return diff < bestDiff ? ev : best;
  });
}

export function EventRedirectPage() {
  const { data: events, isLoading } = useEvents();
  const { user, can } = useAuth();

  if (isLoading) {
    return (
      <div className="space-y-2 py-12">
        <Skeleton className="h-7 w-64 mx-auto" />
      </div>
    );
  }

  if (!events || events.length === 0) {
    return (
      <div className="text-muted-foreground py-12 text-center">
        No events found.
      </div>
    );
  }

  const closest = findClosestEvent(events);

  if (user.team && !can("view-builds")) {
    return <Navigate to={`/events/${closest.id}/team`} replace />;
  }

  return <Navigate to={`/events/${closest.id}`} replace />;
}
